import React from 'react';
import PropTypes from 'prop-types';

const Lightbulb = ({ className, height, width }) => (
  <svg
    className={className}
    height={height}
    viewBox="0 0 20 22"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none">
      <path
        fill="#2B73C7"
        d="M14.227 10.16C14.227 7.317 11.91 5 9.068 5 6.228 5 3.91 7.318 3.91 10.16c0 .408.046.817.16 1.226.136.66.386 1.069.726 1.637.069.136.16.272.25.432.114.181.205.363.319.522.454.75.727 1.182.727 2.068v2.137c0 .545.386.977.909 1.068.227 1.16.91 1.886 2.068 1.886 1.16 0 1.864-.727 2.068-1.886.523-.09.91-.545.91-1.068v-2.137c0-.886.272-1.34.727-2.068.09-.159.204-.34.318-.522.09-.16.182-.296.25-.432.34-.568.59-.978.727-1.637.114-.409.16-.818.16-1.227zm-3.068 6.43H7.023v-.522c0-.113 0-.204-.023-.295h4.16c0 .09-.024.182-.024.295v.523h.023zm-.204 1.796H7.182c-.114 0-.182-.09-.182-.181V17.5h4.136v.705c.023.09-.068.181-.181.181zM9.068 20.25c-.25 0-.886 0-1.136-.955h2.295c-.25.955-.909.955-1.159.955zm4.114-9.045c-.114.5-.296.84-.614 1.363-.09.137-.159.273-.25.432-.113.182-.204.364-.295.5-.273.455-.523.864-.682 1.34h-4.5c-.16-.476-.386-.885-.682-1.34-.09-.16-.204-.318-.295-.5-.091-.16-.182-.318-.25-.432-.319-.545-.5-.863-.614-1.386-.09-.341-.136-.682-.136-1.023 0-2.34 1.909-4.25 4.25-4.25 2.34 0 4.25 1.91 4.25 4.25-.046.341-.091.682-.182 1.046zM3.477 15.114l-1.34 1.34c-.182.182-.182.455 0 .637.09.09.204.136.318.136.113 0 .227-.045.318-.136l1.34-1.341c.182-.182.182-.455 0-.636-.181-.182-.477-.182-.636 0z"
      />
      <path
        fill="#007AFF"
        d="M14.66 15.114c-.183-.182-.455-.182-.637 0-.182.181-.182.454 0 .636l1.34 1.34c.092.092.205.137.319.137.113 0 .227-.045.318-.136.182-.182.182-.455 0-.636l-1.34-1.341z"
      />
      <g fill="#2B73C7">
        <path d="M19.16 9.364h-1.887c-.25 0-.455.204-.455.454s.205.455.455.455h1.886c.25 0 .455-.205.455-.455s-.205-.454-.455-.454zM15.068 5c.114 0 .227-.045.318-.136l1.341-1.341c.182-.182.182-.455 0-.637-.182-.181-.454-.181-.636 0L14.75 4.227c-.182.182-.182.455 0 .637.09.09.205.136.318.136zM9.795 2.795c.25 0 .455-.204.455-.454V.455c0-.25-.205-.455-.455-.455s-.454.205-.454.455V2.34c0 .25.204.454.454.454zM4.205 4.864c.09.09.204.136.318.136.113 0 .227-.045.318-.136.182-.182.182-.455 0-.637L3.5 2.887c-.182-.182-.455-.182-.636 0-.182.181-.182.454 0 .636l1.34 1.34zM2.34 9.364H.456c-.25 0-.455.204-.455.454s.205.455.455.455H2.34c.25 0 .454-.205.454-.455s-.204-.454-.454-.454z" />
      </g>
    </g>
  </svg>
);

Lightbulb.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,

};

Lightbulb.defaultProps = {
  className: undefined,
  height: '22px',
  width: '20px',
};

export default Lightbulb;
